import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { musicProductPhysicalTabs } from 'components/organisms/forms/music-product-physical/MusicProductPhysicalForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePostMusicProductPhysical } from 'services/music-product-physical';
import { usePostMusicProductPhysicalImage } from 'services/music-product-physical/image';
import { IMusicProductPhysicalForm } from 'services/music-product-physical/types/form';
import { getLastTabPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowToast } from 'utils/service/errorHandler';

const CreateMusicProductPhysical = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const createMusicProdutc = usePostMusicProductPhysical();
  const addImage = usePostMusicProductPhysicalImage();

  const mutateOptions = useMutateOptions<IMusicProductPhysicalForm>();

  const goToIndividualMusicProductPhysical = (id: string) =>
    navigate(`/music-product-physical/${id}/${getLastTabPathname(pathname, 3)}`);

  const onCreateMusicProductPhysicalWithFile = async (file: File, id: string, version: number) => {
    await addImage.mutateAsync(
      { file, id, version },
      {
        onError: (error) => {
          onErrorShowToast(error, 'toast-message.add-album-cover');
          goToIndividualMusicProductPhysical(id);
        },
        onSuccess: () => goToIndividualMusicProductPhysical(id),
      },
    );
  };

  const onCreateMusicProductPhysical = async (
    values: IMusicProductPhysicalForm,
    helpers: FormikHelpers<IMusicProductPhysicalForm>,
  ) => {
    const musicProductPhysicalMutation = {
      ...middleware.musicProductPhysical.formToQuery(values),
      waitingForFile: !!values.file,
    };

    await createMusicProdutc.mutateAsync(musicProductPhysicalMutation, {
      ...mutateOptions(helpers),
      onSuccess: async (data) =>
        values.file
          ? onCreateMusicProductPhysicalWithFile(values.file, data.id, data.version)
          : goToIndividualMusicProductPhysical(data.id),
    });
  };

  return (
    <Form.MusicProductPhysical
      i18nextPrefix="music-product-physical"
      onSubmit={onCreateMusicProductPhysical}
      disableTabs={[musicProductPhysicalTabs.external]}
      customBackItem={
        <Button onlyIcon onClick={() => navigate('/music-product-physical')}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
    />
  );
};

export default CreateMusicProductPhysical;
